export default {
  loading: true, // true if connect user is loading
  error: null, // an error
  // isConnected: false,
  user: {}, // user connected
  connectUserId: null
}
